import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import RouterContext from "../../context/RouterContext";
import {updateSeduta} from "../meeting/Utils";
import {properties} from "../../utils/properties";
import { useNavigate } from "react-router-dom";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    List,
    ListItem,
    ListItemText,
    Box,
    Card,
    CardContent,
    Button,
    Stack,
  } from "@mui/material";

  import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function AuditSeduta() {
    const [auditSedute, setAuditSedute] = useState([]);
    // Organo aperto su mobile (accordion a espansione singola). Il primo
    // organo dell'elenco è aperto di default, per dare subito un assaggio
    // del contenuto senza dover impilare tutto sullo schermo.
    const [expandedOrgano, setExpandedOrgano] = useState("Comitato");

    const navigate = useNavigate();

    const { pageRouter, setPageRouter } = useContext(RouterContext);



    const formatData = (str) => {
        const year = str.slice(0, 4);
        const month = str.slice(4, 6);
        const day = str.slice(6, 8);
        return `${day}/${month}/${year}`;
      };

      // Un unico elenco ordinato: alimenta sia la griglia desktop sia
      // l'elenco di accordion su mobile, così l'ordine degli organi resta
      // identico nelle due viste e non serve mantenere due liste separate.
      const tipiOrdinati = ["Comitato", "Consiglio", "Collegio", "CG_PIANETA", "CG_PERSONE", "CG_CULTURA", "CG_FINANZA"];

function convertiLabel(organo) {
    if(organo=="Comitato")
        return "Comitato di Gestione";
    else if(organo=="Collegio")
        return "Collegio Sindacale";
    else if(organo=="Consiglio")
        return "Consiglio Generale";
    else if(organo=="CG_PIANETA")
        return "Commssione Pianeta";
    else if(organo=="CG_CULTURA")
        return "Commssione Cultura";
    else if(organo=="CG_PERSONE")
        return "Commssione Persone";
    else if(organo=="CG_FINANZA")
        return "Commssione Finanza";
    return organo;
}


  function convertiOrganoInColore(organo) {
    if(organo=="Comitato")
        return "#30720f";
    else if(organo=="Consiglio")
        return "#BF360C";
    else if(organo=="Collegio")
        return "#666999";
    else if(organo=="CG_PIANETA")
        return "#008FD1";
    else if(organo=="CG_PERSONE")
        return "#F0B323";
    else if(organo=="CG_CULTURA")
        return "#ce0f69";
    else if(organo=="CG_FINANZA")
        return "#046A38";
    else
        return "#000000";
}



  const auditArgument = (e, index) => {
    console.log("AUDIT ARG",e, index);
    navigate("/audit/" + e.organo + "/"+ e.data_seduta);
};

    // Riga "Seduta del ..." riutilizzata identica sia nella griglia
    // desktop sia negli accordion mobile: pulita, senza accento colore
    // proprio — l'identità dell'organo è già data dal contenitore
    // (barra in alto sulla card desktop, bordo laterale sull'intero
    // accordion mobile), niente più bordi colorati ripetuti su ogni riga.
    const renderSedutaRow = (e, idx) => (
        <div
            className="common-list audit-row"
            key={idx}
            onClick={() => auditArgument(e, idx)}
            style={{ cursor: "pointer" }}
        >
            <p className="textBlackSedute">Seduta del {formatData(e.data_seduta)}</p>
            <div style={{ color: "#879497", display: "flex", alignItems: "center" }}>
                <KeyboardArrowRightIcon sx={{ color: '#879497' }} fontSize="large"/>
            </div>
        </div>
    );

    const getEventiPerOrgano = (organo) =>
        auditSedute
            .filter((e) => e.organo === organo)
            .sort((a, b) => b.data_seduta.localeCompare(a.data_seduta));

    // --- Vista mobile: un accordion per organo, uno aperto alla volta.
    // Un'unica barra colorata (via ::after) copre l'intero Accordion,
    // aperto o chiuso: cresce e si restringe automaticamente insieme al
    // contenuto, senza bisogno di misurare nulla via JS — stesso pattern
    // già usato in ArchivioVerbali.js.
    const renderAccordions = () =>
        tipiOrdinati.map((organo) => {
            const eventiFiltrati = getEventiPerOrgano(organo);
            const colore = convertiOrganoInColore(organo);
            const isOpen = expandedOrgano === organo;
            return (
                <Accordion
                    key={organo}
                    className="audit-accordion"
                    expanded={isOpen}
                    onChange={() => setExpandedOrgano(isOpen ? null : organo)}
                    disableGutters
                    style={{
                        backgroundColor: "white",
                        marginBottom: "12px",
                        boxShadow: "none",
                        border: "1px solid #e0e0e0",
                        borderRadius: "10px",
                        position: "relative",
                    }}
                    sx={{
                        "&:before": { display: "none" },
                        "&::after": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            right: 0,
                            width: "8px",
                            height: "100%",
                            backgroundColor: colore,
                            borderTopRightRadius: "10px",
                            borderBottomRightRadius: "10px",
                        },
                    }}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ paddingRight: "20px" }}>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                            <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
                                {convertiLabel(organo)}
                            </Typography>
                            <Typography sx={{ color: "#879497", fontSize: "13px", marginRight: "8px" }}>
                                {eventiFiltrati.length} sedut{eventiFiltrati.length === 1 ? "a" : "e"}
                            </Typography>
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails className="audit-accordion-details" sx={{ padding: "0px 12px 8px 12px" }}>
                        {eventiFiltrati.length > 0 ? (
                            eventiFiltrati.map((e, idx) => renderSedutaRow(e, idx))
                        ) : (
                            <Typography sx={{ color: "#879497", padding: "8px" }}>
                                Nessuna seduta disponibile
                            </Typography>
                        )}
                    </AccordionDetails>
                </Accordion>
            );
        });

    // --- Vista desktop: due gruppi visivi distinti (i 3 organi principali,
    // poi le 4 commissioni), ciascuna card con altezza costante — oltre le
    // prime righe visibili si scorre internamente invece di far crescere
    // la card, così tutte le card di un gruppo restano allineate in altezza
    // indipendentemente dal numero di sedute che contengono.
    const renderOrganoCard = (organo) => {
        const eventiFiltrati = getEventiPerOrgano(organo);
        const colore = convertiOrganoInColore(organo);
        return (
            <Card
                key={organo}
                className="audit-card"
                sx={{
                    borderTop: `4px solid ${colore}`,
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
                }}
            >
                <CardContent sx={{ paddingBottom: "8px !important" }}>
                    <Typography align="left" variant="h6" fontWeight="bold">
                        {convertiLabel(organo)}
                    </Typography>
                </CardContent>
                <Box className="audit-card-list" sx={{ display: "flex", flexDirection: "column", gap: "8px", padding: "0px 8px 8px 8px", overflowY: "auto" }}>
                    {eventiFiltrati.length > 0 ? (
                        eventiFiltrati.map((e, idx) => renderSedutaRow(e, idx))
                    ) : (
                        <Typography sx={{ color: "#879497", padding: "8px" }}>
                            Nessuna seduta disponibile
                        </Typography>
                    )}
                </Box>
            </Card>
        );
    };

    const organiPrincipali = ["Comitato", "Consiglio", "Collegio"];
    const commissioni = ["CG_PIANETA", "CG_PERSONE", "CG_CULTURA", "CG_FINANZA"];


    const updateUI = function(auditData) {
        console.log("UPDATEUI",auditData);
        setAuditSedute(auditData);
    }

    const doPostGetAuditSedute = function() {
        if( properties.verboseLog==1)
            console.log("doing sedute post");
        var xhr2 = new XMLHttpRequest();
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix+'/core/rest/getAuditSedute.php',true);

        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr2.withCredentials = true;
        xhr2.onload = function (e) {
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {
                    if( properties.verboseLog==1)
                        console.log("OK92",xhr2);
                    var responseText = xhr2.responseText;
                    var obj=JSON.parse(responseText);
                    console.log("OK93",obj);
                    updateUI(obj);
                }
                else {
                    console.error("Error 15", xhr2.statusText);
                    window.alert("Errore recuperando la seduta 9");
                    navigate("/init",{ replace: true });
                }
            }
        };

        xhr2.onerror = function (e) {
            console.error("Error 25", xhr2.statusText);
        };

        let urlEncodedData = "";

        console.log("AUDITSEDUTE",urlEncodedData);
        xhr2.send(urlEncodedData);
}


    useEffect(() => {
        if(!window.cordova){
        //CHECK AUTHENTICATION
        var xhr = new XMLHttpRequest();
        xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix+'/core/rest/ping.php',true);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

        xhr.onload = function (e) {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    if( properties.verboseLog==1)
                        console.log("OK",xhr);
                        doPostGetAuditSedute();
                } else {
                    console.error("Error 5", xhr);
                    localStorage.clear();
                    navigate("/login");
                }
            }
        };

        xhr.onerror = function (e) {
          console.error("Error 75", xhr);
          localStorage.clear();
          navigate("/login");
        };

        let urlEncodedData = null;
        xhr.send(urlEncodedData);
        //CHECK AUTHENTICATION
        }

        if (window.cordova){
            doPostGetAuditSedute();
        }
    }, []);


    return (

        <div className="audit-page" style={{ background: "#f5f5f5",
            padding: "30px 5%",
            minHeight: "calc(100vh - 136px)",
            display: "flex",
            flexDirection: "column" }}>

        <Typography variant="h5" align="left" className="audit-title" sx={{paddingBottom:"10px", paddingLeft:"10px"}}>
                {"Statistiche di accesso:"}  {"seleziona l'organo e la seduta di interesse per visualizzarne le statistiche"}
        </Typography>

        {/* Vista mobile: un accordion per organo, uno aperto alla volta */}
        <Box className="audit-mobile-view">
            {renderAccordions()}
        </Box>

        {/* Vista desktop: due gruppi visivi distinti — i 3 organi
            principali (Comitato, Consiglio, Collegio), poi le 4
            commissioni, ciascuno raggruppato nella propria riga */}
        <Box className="audit-desktop-view">
            <Box className="audit-group">
                {organiPrincipali.map(renderOrganoCard)}
            </Box>
            <Box className="audit-group">
                {commissioni.map(renderOrganoCard)}
            </Box>
        </Box>

        </div>
    );
}
